(function ($) {

  irisValidation($('#talk-to-our-team'), {
    focusFirstInput: false,
    validators: {
      firstname: 'firstName',
      lastname: 'lastName',
      email: 'email',
      company: 'companyName',
    },
    filters: {},
    validateByTimeout: ['email'],
    errorMessages: {
      required: 'This field is required',
      emailFormat: 'Not a valid email',
      connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
    },
    success: function (data) {
      $(this.formSelector + ' .form-group').css({opacity: 0});
      this.showResult("<p>Thank you for your interest. We'll be in touch soon. To immediately schedule a meeting, <a href=\"https://nmi.chilipiper.com/book/sdr-website\">click here</a>.</p>", true);
    }
  });


})(jQuery);
